import { render } from "./UploadRoutes.vue?vue&type=template&id=c56e1506&scoped=true"
import script from "./UploadRoutes.vue?vue&type=script&lang=js"
export * from "./UploadRoutes.vue?vue&type=script&lang=js"

import "./UploadRoutes.vue?vue&type=style&index=0&id=c56e1506&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c56e1506"]])

export default __exports__